<div class="chat-launcher bg-primary shadow-lg rounded-circle d-flex align-items-center justify-content-center"
  (click)="chatVisibility()">
  <span class="pulse-effect bg-info rounded-circle position-absolute w-100 h-100" *ngIf="!chatScreenShow"></span>
  <div class="launcher-content position-relative w-100 h-100 d-flex align-items-center justify-content-center"
    [class.rotate-active]="chatScreenShow">
    <div *ngIf="!chatScreenShow"
      class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center launcher-icon">
      <img src="/assets/chatbot_icon__1_-removebg-preview.png" alt="Chat" class="img-fluid drop-shadow"
        style="height:3.5rem;">
    </div>
    <div *ngIf="chatScreenShow" class="position-absolute w-100 h-100 d-flex align-items-center justify-content-center">
      <mat-icon class="text-white fs-3 transition-icon">close</mat-icon>
    </div>
  </div>
</div>

<!-- Chat Window -->
<div class="chat-window bg-light shadow-lg d-flex flex-column custom-chat-border" [class.chat-hidden]="!chatScreenShow"
  [class.chat-visible]="chatScreenShow">

  <!-- Header -->
  <div class="chat-header position-relative overflow-hidden">
    <div class="header-mesh"></div>
    <div class="header-glow header-glow-1"></div>
    <div class="header-glow header-glow-2"></div>
    <div class="header-shimmer"></div>

    <div class="header-inner d-flex align-items-center justify-content-between position-relative">
      <!-- Left Section -->
      <div class="d-flex align-items-center gap-3">
        <div class="header-avatar-wrap position-relative">
          <div class="avatar-ring-outer"></div>
          <div class="header-avatar">
            <img src="/assets/chatbot_icon__1_-removebg-preview.png" alt="Bot">
          </div>
          <span class="avatar-status-dot"></span>
        </div>
        <div class="d-flex flex-column">
          <span class="header-title">MI IDP Assistant</span>
          <span class="header-status">
            <span class="status-pulse-dot"></span>
            Online Now
          </span>
        </div>
      </div>

      <!-- Right Section -->
      <div class="d-flex align-items-center gap-2">
        <button mat-icon-button [matMenuTriggerFor]="menu" class="header-action-btn" title="More">
          <mat-icon>more_vert</mat-icon>
        </button>
      </div>
    </div>

    <mat-menu #menu="matMenu" class="custom-menu-refined">
      <button mat-menu-item (click)="onEndChat()" class="menu-item-end">
        <mat-icon class="text-danger">power_settings_new</mat-icon>
        <span class="fw-bold text-dark">End Session</span>
      </button>
    </mat-menu>
  </div>

  <!-- Sliding Call Container -->
  <div class="ccp-slider position-absolute" [class.ccp-hidden]="!showIframe" [class.ccp-visible]="showIframe">
    <div class="call-panel d-flex flex-column align-items-center h-100 text-center">

      <!-- Idle State -->
      <ng-container *ngIf="callState === 'idle'">
        <div class="call-idle-content d-flex flex-column align-items-center justify-content-center flex-grow-1 px-4">
          <div class="idle-illustration mb-4">
            <div class="idle-ring idle-ring-1"></div>
            <div class="idle-ring idle-ring-2"></div>
            <div class="idle-icon-circle">
              <mat-icon class="text-white" style="font-size:1.8rem;width:1.8rem;height:1.8rem;">support_agent</mat-icon>
            </div>
          </div>
          <h6 class="idle-title">Voice Assistant</h6>
          <p class="idle-subtitle">Talk to our AI-powered assistant in real-time. Just click below to begin.</p>
          <button class="btn call-start-btn text-white fw-bold d-flex align-items-center justify-content-center gap-2"
            (click)="startVoiceCall()">
            <mat-icon style="font-size:1.1rem;width:1.1rem;height:1.1rem;">call</mat-icon>
            Start Voice Call
          </button>
        </div>
        <div class="call-panel-footer">
          <mat-icon style="font-size:0.8rem;width:0.8rem;height:0.8rem;vertical-align:middle;">verified_user</mat-icon>
          Secure &amp; encrypted connection
        </div>
      </ng-container>

      <!-- Connecting State -->
      <ng-container *ngIf="callState === 'connecting'">
        <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1 px-4">
          <div class="connecting-anim mb-4">
            <div class="ring ring-1"></div>
            <div class="ring ring-2"></div>
            <div class="ring ring-3"></div>
            <div class="connecting-center">
              <mat-icon class="text-white" style="font-size:1.6rem;width:1.6rem;height:1.6rem;">ring_volume</mat-icon>
            </div>
          </div>
          <h6 class="connecting-title">Connecting<span class="dot-anim">...</span></h6>
          <p class="connecting-subtitle">Setting up your secure call with the AI assistant</p>
          <div class="connecting-steps">
            <div class="step-item active">
              <div class="step-dot"></div>
              <span>Initializing</span>
            </div>
            <div class="step-line"></div>
            <div class="step-item">
              <div class="step-dot"></div>
              <span>Authenticating</span>
            </div>
            <div class="step-line"></div>
            <div class="step-item">
              <div class="step-dot"></div>
              <span>Connected</span>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Connected State -->
      <ng-container *ngIf="callState === 'connected'">
        <div class="connected-bg-decor"></div>
        <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1 px-4 position-relative">
          <div class="connected-avatar-area mb-2">
            <div class="avatar-orbit"></div>
            <div class="avatar-pulse-ring"></div>
            <div class="ai-avatar-wrapper">
              <img src="/assets/ai-assistant-avatar.png" alt="AI Assistant" class="ai-avatar-img">
            </div>
          </div>

          <div class="connected-status-badge mb-1">
            <span class="status-dot-live"></span>
            Live Call
          </div>
          <div class="call-timer">{{ callTimer }}</div>
          <p class="connected-hint">Speak naturally — the AI is listening</p>

          <div class="visualizer-container mb-4" [class.paused]="callMuted">
            <div class="v-bar" *ngFor="let b of visualizerBars"></div>
          </div>

          <div class="call-actions d-flex justify-content-center gap-3">
            <button class="btn call-action-btn mute-btn" [class.active]="callMuted" (click)="toggleCallMute()">
              <div class="action-icon-wrap">
                <mat-icon>{{ callMuted ? 'mic_off' : 'mic' }}</mat-icon>
              </div>
              <span>{{ callMuted ? 'Unmute' : 'Mute' }}</span>
            </button>
            <button class="btn call-action-btn end-btn" (click)="endVoiceCall()">
              <div class="action-icon-wrap">
                <mat-icon>call_end</mat-icon>
              </div>
              <span>End</span>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Error State -->
      <ng-container *ngIf="callState === 'error'">
        <div class="d-flex flex-column align-items-center justify-content-center flex-grow-1 px-4">
          <div class="error-icon-wrap mb-3">
            <mat-icon style="font-size:2rem;width:2rem;height:2rem;">error_outline</mat-icon>
          </div>
          <h6 class="error-title">Connection Failed</h6>
          <p class="error-subtitle">{{ callError }}</p>
          <button class="btn call-start-btn text-white fw-bold d-flex align-items-center justify-content-center gap-2"
            (click)="startVoiceCall()">
            <mat-icon style="font-size:1rem;width:1rem;height:1rem;">replay</mat-icon>
            Try Again
          </button>
        </div>
      </ng-container>

    </div>
    <audio #remoteAudio autoplay></audio>
  </div>

  <!-- Chat Body -->
  <div #chatContainer class="chat-body flex-grow-1 p-3 overflow-auto custom-scrollbar" *ngIf="!chatEnd">
    <div class="text-center py-2">
      <span class="badge bg-white text-muted border border-light shadow-sm fw-bold px-3 py-1 rounded-pill time-badge">
        {{ currentDateTime | date: 'EEEE, h:mm a' }}
      </span>
    </div>

    <ng-container *ngFor="let message of chatMessages">
      <div class="message-wrapper d-flex gap-2 w-100 mb-3" [ngClass]="{'justify-content-end': message.sender === 'me'}">

        <!-- Avatar for Bot -->
        <div class="message-avatar rounded bg-white shadow-sm border" *ngIf="message.sender !== 'me'">
          <img src="/assets/chatbot_icon__1_-removebg-preview.png" alt="Bot"
            class="w-100 h-100 object-fit-cover rounded">
        </div>

        <div class="d-flex flex-column max-w-75" [ngClass]="{'align-items-end': message.sender === 'me'}">
          <!-- Message Bubble -->
          <div class="message-bubble p-3 shadow-sm position-relative"
            [ngClass]="message.sender === 'me' ? 'bubble-me text-white' : 'bubble-bot bg-white text-dark border'">

            <div [innerHTML]="getSafeHtml(message?.text)" class="markdown-content"></div>

            <!-- PDF Links -->
            <div *ngIf="message?.pdf_links && message.pdf_links.length > 0" class="mt-2 pt-2 border-top border-light">
              <p class="resources-title text-muted fw-bold mb-2 text-uppercase">Resources</p>
              <div class="d-flex flex-column gap-2">
                <a *ngFor="let pdf of message.pdf_links" [href]="pdf.url" target="_blank"
                  class="pdf-link text-decoration-none d-flex align-items-center gap-2 p-2 rounded bg-light border hover-shadow">
                  <div
                    class="pdf-icon bg-danger bg-opacity-10 border border-danger border-opacity-25 rounded d-flex align-items-center justify-content-center">
                    <mat-icon class="text-danger">picture_as_pdf</mat-icon>
                  </div>
                  <div class="d-flex flex-column overflow-hidden">
                    <span class="pdf-title fw-bold text-dark text-truncate">{{ pdf?.title }}</span>
                    <span class="pdf-subtitle text-muted fw-bold text-uppercase">View Document</span>
                  </div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Loading Indicator -->
    <div class="message-wrapper d-flex gap-2 w-100 mb-3" *ngIf="setLoading">
      <div class="message-avatar rounded bg-white shadow-sm border">
        <img src="/assets/chatbot_icon__1_-removebg-preview.png" alt="Bot" class="w-100 h-100 object-fit-cover rounded">
      </div>
      <div class="bg-white border rounded shadow-sm p-3 d-flex align-items-center gap-1 loading-dots">
        <span class="dot bg-primary rounded-circle"></span>
        <span class="dot bg-primary rounded-circle"></span>
        <span class="dot bg-primary rounded-circle"></span>
      </div>
    </div>
  </div>

  <!-- Chat Input Area -->
  <div class="chat-input-area p-3 bg-white border-top z-1" *ngIf="!chatEnd && chatType">
    <div class="position-relative">
      <div class="input-wrapper d-flex align-items-end gap-2 bg-light border rounded px-2 py-1 focus-ring-primary">
        <textarea rows="1" placeholder="Type your message..."
          class="form-control border-0 bg-transparent shadow-none resize-none custom-textarea" [(ngModel)]="chatBox"
          (keydown)="handleKeyDown($event)" #autoTextarea (input)="autoGrow(autoTextarea)"></textarea>

        <button class="btn btn-primary d-flex align-items-center justify-content-center rounded-circle send-btn"
          (click)="sendMessage()" [disabled]="!chatBox || chatBox.trim() === ''">
          <mat-icon>send</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <!-- Session Ended -->
  <div
    class="session-ended flex-grow-1 p-4 d-flex flex-column align-items-center justify-content-center text-center bg-white"
    *ngIf="chatEnd">
    <div
      class="end-icon-wrapper bg-success bg-opacity-10 text-success rounded-circle d-flex align-items-center justify-content-center mb-4 shadow">
      <mat-icon style="font-size: 3rem; width: 3rem; height: 3rem;">check_circle_outline</mat-icon>
    </div>
    <h5 class="fw-bolder text-dark mb-2 text-uppercase">Session Ended</h5>
    <p class="small text-muted mb-4 w-75 mx-auto">Your data has been saved. Thank you for using Flint Housing AI
      Services.</p>

    <button
      class="btn btn-dark fw-bold px-4 py-2 rounded text-uppercase letter-spacing-wide w-75 shadow-sm btn-close-session"
      (click)="chatVisibility()">
      Close Interface
    </button>

    <div class="mt-auto small text-muted text-uppercase fw-bold letter-spacing-wide opacity-50">
      Flint Housing Intelligent Systems
    </div>
  </div>

</div>